module.exports = __webpack_public_path__ + "img/13.519050c4.png";